import { render, staticRenderFns } from "./paya_amount_confirmation.vue?vue&type=template&id=439d59b6&"
import script from "./paya_amount_confirmation.vue?vue&type=script&lang=js&"
export * from "./paya_amount_confirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports